const StringUtils = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  replaceStr(...args: any[]) {
    if (args.length < 1 || args[0] === undefined) {
      return "";
    }
    const arr = args[0].split("{}");
    let result = "";
    for (let i = 0; i < arr.length - 1; i++) {
      result += arr[i] + args[i + 1];
    }
    result += arr[arr.length - 1];
    return result;
  },
};
export default StringUtils;
